window.addEventListener('load', () => {
  jQuery('.franchise-form-scroll-to').on('click', (event) => {
    event.preventDefault();

    jQuery('html, body').animate({
      scrollTop: $("#franchise-form").offset().top,
    }, 400);
  });
});



// WEBPACK FOOTER //
// ./scripts/routes/franchise.js